import { render } from "./el-search.vue?vue&type=template&id=0ad27965&scoped=true"
import script from "./el-search.vue?vue&type=script&lang=ts"
export * from "./el-search.vue?vue&type=script&lang=ts"

import "./el-search.vue?vue&type=style&index=0&id=0ad27965&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-0ad27965"

export default script